import { GET_LEADERBOARDS, GET_LEADERBOARDS_SUCCESS, GET_LEADERBOARDS_FAILURE } from "./actionTypes"
export const getLeaderboards = () => ({ type: GET_LEADERBOARDS })
export const getLeaderboardsSuccess = payload => ({ type: GET_LEADERBOARDS_SUCCESS, payload })
export const getLeaderboardsFailure = () => ({ type: GET_LEADERBOARDS_FAILURE })
